// extracted by mini-css-extract-plugin
export default {"saveButton":"SendEmail_saveButton__GGRWZ"};